"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "preferences_panel preferences_panel--language-switcher" };
const _hoisted_2 = { class: "preferences_panel_item form-group" };
const _hoisted_3 = { class: "preferences_panel_langs" };
const _hoisted_4 = ["title", "onClick"];
const _hoisted_5 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ALL_LANGUAGES, (lang) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                        class: "form-radio",
                        key: lang
                    }, [
                        ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: lang,
                            class: (0, vue_1.normalizeClass)(`language-icon language-icon-for-switcher language-icon--${lang}`),
                            title: _ctx.LANGUAGES[lang][1],
                            onClick: ($event) => (_ctx.switchLanguageTo(lang))
                        }, null, 10, _hoisted_4)),
                        (0, vue_1.createElementVNode)("span", {
                            class: "language-text",
                            onClick: ($event) => (_ctx.switchLanguageTo(lang))
                        }, (0, vue_1.toDisplayString)(_ctx.LANGUAGES[lang][0]), 9, _hoisted_5)
                    ]));
                }), 128))
            ])
        ])
    ]));
}
